import { useEffect, useRef, useState } from "react";
import axios from "axios";

export default function useBatchJobPolling(jobIds, token, interval = 3000) {
  const [jobDetails, setJobDetails] = useState([]);
  const [progress, setProgress] = useState({ completed: 0, total: 0, percent: 0 });
  const timer = useRef();

  useEffect(() => {
    let isMounted = true;

    async function fetchJobs() {
      if (!jobIds || jobIds.length === 0) {
        if (isMounted) setProgress({ completed: 0, total: 0, percent: 0 });
        return;
      }
      try {
        const results = await Promise.all(
          jobIds.map((id) =>
            axios
              .post(
                `${process.env.REACT_APP_API_HOST}/v2/job/getJobById`,
                { _id: id, jobType: "callai" },
                { headers: { Authorization: `Bearer ${token}` } }
              )
              .then((res) => res.data)
          )
        );
        if (isMounted) setJobDetails(results);

        // Calculate progress
        const total = results.length;
        const completed = results.filter(job => job.status === "completed" || job.status === 'error').length;
        const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
        if (isMounted) setProgress({ completed, total, percent });

        // Stop polling if all jobs are completed
        if (total > 0 && completed === total) {
          clearInterval(timer.current);
        }
      } catch (e) {
        console.error("Error fetching job details:", e);
        // handle error if needed
      }
    }

    fetchJobs();
    timer.current = setInterval(fetchJobs, interval);

    return () => {
      isMounted = false;
      clearInterval(timer.current);
    };
  }, [jobIds, interval, token]);

  return { jobDetails, progress };
}